import React from 'react';
import { AlertTriangleIcon, CheckIcon, StarIcon } from 'lucide-react';
import { purchaseUrls } from '../data/content';
import { Button } from './ui/Button';
const baseFeatures = ['5 Tomos PDF completos (Movilidad, Fortalecimiento, Zona Lumbar, Postura y Entrenamiento)', '5 Bonos estratégicos gratis', 'Tabla de progresión de 12 semanas', 'Acceso inmediato', 'Garantía de 7 días'];
const premiumFeatures = ['Todo el Combo Completo Espalda y Columna', '40 rutinas adicionales listas para usar', 'Rutinas de 10, 15, 20, 30 y 45 minutos', 'Calendario semanal detallado por 12 meses', 'Fichas de seguimiento y evaluación trimestral'];
function PlanCard({
  premium = false
}: {
  premium?: boolean;
}) {
  const features = premium ? premiumFeatures : baseFeatures;
  const title = premium ? 'Combo + Mega Kit Espalda 365' : 'Combo Completo Espalda y Columna';
  const subtitle = premium ? '5 Tomos + 5 Bonos + 40 Rutinas Extra' : '5 Tomos + 5 Bonos';
  const price = premium ? '$27.990' : '$19.990';
  const before = premium ? '$82.990' : '$65.000';
  const savings = premium ? '$55.000' : '$45.000';
  return <article className={`relative flex flex-col rounded-3xl p-6 md:p-8 ${premium ? 'border-4 border-gold bg-primary text-white shadow-[0_25px_60px_rgba(14,165,233,.35)] ring-4 ring-gold/30 md:scale-[1.025]' : 'border border-sky-100 bg-white shadow-sm'}`} data-id="element-204" data-mp="2apt128q1p5hj">
      {premium && <div className="absolute -top-4 left-1/2 flex -translate-x-1/2 items-center gap-1 whitespace-nowrap rounded-full border-2 border-amber-200 bg-gold px-4 py-1.5 text-xs font-extrabold text-white shadow-lg" data-id="element-205" data-mp="2yklwsk8iclo3">
          <StarIcon className="h-4 w-4 fill-current" data-id="element-206" data-mp="38e2rrrkds6tc" /> MÁS ELEGIDO
        </div>}
      <div className={premium ? 'mt-2' : ''} data-id="element-207" data-mp="33f9pywegi490">
        <div className="flex items-start gap-2" data-id="element-208" data-mp="3hc6f8texfdns">
          <span className="text-3xl" data-id="element-209" data-mp="3havbgtlhe5wo">{premium ? '💎' : '📚'}</span>
          <h3 className={`text-xl font-extrabold leading-tight ${premium ? 'text-white' : 'text-slate-900'}`} data-id="element-210" data-mp="3cewkqzcokbt3">
            {title}
          </h3>
        </div>
        <p className={`mt-2 text-sm font-medium ${premium ? 'text-sky-50' : 'text-slate-500'}`} data-id="element-211" data-mp="2eyqpiai205gu">
          {subtitle}
        </p>
      </div>

      <ul className="my-6 flex-1 space-y-2" data-id="element-212" data-mp="2izu5cx03q1i2">
        {features.map(feature => <li key={feature} className={`flex items-start gap-2 text-sm font-medium ${premium ? 'text-white' : 'text-slate-700'}`} data-id="element-213" data-mp="2ntestv42jd30">
            <CheckIcon className={`mt-0.5 h-4 w-4 shrink-0 ${premium ? 'text-amber-300' : 'text-accent'}`} data-id="element-214" data-mp="2xpi2rn55wg0i" />
            {feature}
          </li>)}
      </ul>

      <div className="mb-6 mt-auto" data-id="element-215" data-mp="36r7xp2y95x31">
        <span className={`mb-3 inline-block rounded-full px-3 py-1 text-xs font-extrabold ${premium ? 'bg-gold text-white' : 'bg-sky-100 text-accent'}`} data-id="element-216" data-mp="36q687tghp81s">
          AHORRÁS {savings}
        </span>
        <p className={`mt-2 text-sm font-bold line-through ${premium ? 'text-sky-100' : 'text-slate-400'}`} data-id="element-217" data-mp="1ccyigg7dfmn0">
          Antes: {before}
        </p>
        <p className={`mt-1 text-xs font-bold uppercase ${premium ? 'text-sky-50' : 'text-slate-500'}`} data-id="element-218" data-mp="101eb3pnoqc81">
          Hoy
        </p>
        <p className={`text-4xl font-extrabold ${premium ? 'text-white md:text-5xl' : 'text-slate-900'}`} data-id="element-219" data-mp="v0zzxyqsem5s">
          {price}
        </p>
      </div>

      <Button href={premium ? purchaseUrls.premium : purchaseUrls.base} fullWidth className={premium ? 'border-2 border-amber-100 bg-gold text-xs shadow-[0_0_0_5px_rgba(245,158,11,.28)] hover:bg-amber-600' : 'text-xs'} data-id="element-220" data-mp="1nri47338ytks">
        {premium ? 'QUIERO COMBO + MEGA KIT 365' : 'QUIERO EL COMBO COMPLETO'}
      </Button>
    </article>;
}
export function Pricing({
  id = 'pricing'
}: {
  id?: string;
}) {
  return <section id={id} className="mx-auto max-w-6xl scroll-mt-16 px-4 pb-16 pt-12 md:pb-24 md:pt-16" data-id="element-221" data-mp="3uhgb9x411v7x">
      <div className="text-center" data-id="element-222" data-mp="1m8zy7rup5qwg">
        <p className="text-[11px] font-bold uppercase tracking-[.16em] text-accent md:text-sm" data-id="element-223" data-mp="1m7oyq48ab5b5">
          ⏰ Precio de lanzamiento activo hoy
        </p>
        <h2 className="mx-auto mt-3 max-w-2xl text-2xl font-extrabold leading-tight text-slate-900 md:text-4xl" data-id="element-224" data-mp="1da4tkk7awov9">
          Elegí tu opción y asegurá el precio{' '}
          <span className="text-accent" data-id="element-225" data-mp="2509imw60a02t">antes de que suba.</span>
        </h2>
        <div className="mt-5 flex flex-wrap justify-center gap-2" data-id="element-226" data-mp="24y6j9liyqulf">
          {['Después sube $9.000 ARS', 'Esta promo no vuelve'].map(item => <span key={item} className="inline-flex items-center gap-1 rounded-full border border-red-200 bg-red-50 px-3 py-1.5 text-[11px] font-bold text-red-600" data-id="element-227" data-mp="1w0e3kg9bxkxi">
              <AlertTriangleIcon className="h-3.5 w-3.5" data-id="element-228" data-mp="kjectp2mre5l" />
              {item}
            </span>)}
        </div>
      </div>

      <div className="mx-auto mt-10 grid max-w-5xl gap-8 md:grid-cols-2" data-id="element-229" data-mp="phfvwa023dh2">
        <PlanCard data-id="element-230" data-mp="h173ufzs1xk3" />
        <PlanCard premium data-id="element-231" data-mp="h0p3p89zuz6w" />
      </div>
      <p className="mt-8 text-center text-xs font-medium text-slate-500" data-id="element-232" data-mp="d16pevcohmd1">
        Pago 100% seguro · Acceso en 5 minutos · Mercado Pago hasta 12 cuotas
      </p>
    </section>;
}